var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4805 2.30859L13.4414 1.26953C13.1133 0.941406 12.6484 0.75 12.2109 0.75C11.7734 0.75 11.3086 0.941406 10.9805 1.26953L8.92969 3.32031L8 4.25L1.32812 10.9219L1 14.0391C0.945312 14.4219 1.24609 14.75 1.62891 14.75C1.65625 14.75 1.68359 14.75 1.71094 14.75L4.82812 14.4219L11.5 7.75L12.4297 6.82031L14.4805 4.76953C15.1641 4.08594 15.1641 2.99219 14.4805 2.30859ZM4.22656 13.1641L2.39453 13.3555L2.58594 11.5234L8.90234 5.17969L9.75 4.33203L11.418 6L10.5703 6.84766L4.22656 13.1641ZM13.5508 3.83984L12.3477 5.07031L10.6797 3.40234L11.9102 2.19922C12.0195 2.08984 12.1562 2.0625 12.2109 2.0625C12.2656 2.0625 12.4023 2.08984 12.5117 2.19922L13.5508 3.23828C13.7148 3.40234 13.7148 3.67578 13.5508 3.83984Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.01f17a8a.svg";
export { ForwardRef as ReactComponent };